import T from './types';

export const setAnswerViewportRelative = (id: string, inViewport: boolean) => ({
  type: T.IS_IN_VIEWPORT,
  payload: { id, inViewport },
});
